export function isIosDevice() {
  if (typeof window === 'undefined') {
    return false
  }
  const userAgent = navigator.userAgent
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return true
  }
  // For iPadOS 13+ the user agent may not explictly contain 'iPad'
  if (userAgent.includes('Macintosh') && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) {
    return true
  }
  return false
}

export function isMacDevice() {
  if (typeof window === 'undefined') {
    return false
  }
  return /Mac OS/.test(navigator.userAgent)
}

export function isSafari() {
  if (typeof window === 'undefined') {
    return false
  }
  const userAgent = navigator.userAgent.toLowerCase()
  return (
    userAgent.includes('safari') && !userAgent.includes('chrome') && !userAgent.includes('android')
  )
}
